import {secured} from '../../../axios';

export const getUserSubscription = async () => {
  return await secured.get('/users/subscriptions').then(res => res.data);
};

export const cancelUserSubscription = async () => {
  return await secured.delete('/users/subscriptions');
};
